export class OtpEventArgs{
    mobile:string = '';
    email:string = '';
    otpCode:string = '';
    firstName:string = '';
    lastName:string = '';
    otpNonce:string = '';
    otpHash:string = '';

    privacyPolicyConsented:boolean = false;
}